<template>
  <div class="menuFrame">
    <loading :active.sync="isLoading"></loading>

    <div id="track">
      <div class="d-flex justify-content-between">
        <div>
          <a class="linkstyle" href="https://www.chanchao.com.tw/ExhibitorServiceTW/">展覽列表</a><span>/</span>
          <em name="Exhibition">{{ ExhibitionName }}</em>
        </div>
        <div>
          <span class="bold">登入帳號 :</span>
          <span> {{ UserId }}</span>
        </div>
      </div>
    </div>
    <!-- track end -->
    <!-- article -->
    <article>
      <div class="homeLeft">
        <div class="MbDevice">
          <div class="UserAccount ml-1">
            <span class="bold">登入帳號 :</span>
            <span> {{ UserId }}</span>
          </div>
          <hr />
        </div>

        <div class="expoLogo">
          <div class="imgCorp squareThumb">
            <img :src="ExhLogo" width="100%" />
          </div>
        </div>
        <div class="expoInfo">
          <p class="bold" name="Exhibition">{{ ExhibitionName }}</p>
          <p>{{ Exhdate }}</p>
          <p>{{ ExhVenue }}</p>
        </div>
        <p class="clear"></p>
      </div>
      <div class="homeRight">
        <h1>{{ Directory_ComName }}</h1>
        <p class="my-3">&nbsp;</p>
        <ul id="progress">
          <li class="progressEdit">
            <div class="progressLeft">
              <div class="profile">
                <h3>
                  <!-- 公司資訊 -->
                  <span name="homeCompanyInfo"></span>
                  <span class="icon incomplete ml-1"></span>
                </h3>
                <p>請上傳公司 LOGO，並填寫展出品牌填寫資訊</p>
              </div>
            </div>
            <div class="progressRight">
              <div>
                <p>
                  <a :href="`https://www.chanchao.com.tw/ExhibitorServiceTW/profile?no=${RegNo}`" class="btnStyle">
                    編輯</a
                  >
                </p>
              </div>
            </div>
            <p class="clear"></p>
          </li>
          <li class="progressBook">
            <div class="progressLeft">
              <div class="directory">
                <h3>
                  <span name="homeDirectoryTitle"></span>
                  <span class="icon incomplete ml-1"></span>
                </h3>
                <p class="HasDirectory">
                  請於 <span class="red">{{ DirectoryDeadline }}</span> 前登錄本年度的大會專刊資訊
                </p>
                <p class="NoDirectory">請上傳公司名稱、網址、廠商/產品介紹，將露出於官網->參展商列表</p>
              </div>
            </div>
            <div class="progressRight">
              <div>
                <p>
                  <a :href="`https://www.chanchao.com.tw/ExhibitorServiceTW/directory?no=${RegNo}`" class="btnStyle"
                    >編輯</a
                  >
                </p>
              </div>
            </div>
            <p class="clear"></p>
          </li>
          <li class="progressProd">
            <div class="progressLeft">
              <div>
                <h3>參展產品</h3>
                <p>
                  請建立產品資訊，您已經建立
                  <span class="red">{{ existProNum }}</span> 個產品，還可以建立
                  <span class="red">{{ leftProNum }}</span> 個產品
                </p>
              </div>
            </div>
            <div class="progressRight">
              <div>
                <p>
                  <a :href="`https://www.chanchao.com.tw/ExhibitorServiceTW/product?no=${RegNo}`" class="btnStyle"
                    >編輯</a
                  >
                </p>
              </div>
            </div>
            <p class="clear"></p>
          </li>
          <li class="progressNews">
            <div class="progressLeft">
              <div>
                <h3>新聞稿</h3>
                <p>
                  請發佈新聞稿，您已經發佈 <span class="red">{{ existNewsNum }}</span> 個新聞稿，還可以發佈
                  <span class="red">{{ leftNewsNum }}</span> 個新聞稿
                </p>
              </div>
            </div>
            <div class="progressRight">
              <div>
                <p>
                  <a :href="`https://www.chanchao.com.tw/ExhibitorServiceTW/news?no=${RegNo}`" class="btnStyle">編輯</a>
                </p>
              </div>
            </div>
            <p class="clear"></p>
          </li>
          <li class="progressInvit">
            <div class="progressLeft">
              <div>
                <h3>客戶邀請</h3>
                <p>歡迎使用電子邀請函、代理申請、VIP申請邀請重要客戶。</p>
              </div>
            </div>
            <div class="progressRight">
              <div>
                <p><a href="" class="btnStyle getInvUrl">邀請</a></p>
              </div>
            </div>
            <p class="clear"></p>
          </li>
        </ul>
      </div>
      <p class="clear"></p>
    </article>
  </div>
</template>

<script>
  import $ from 'jquery'
  import axios from 'axios'

  export default {
    data() {
      return {
        ExhVenue: '',
        ExhLogo: '',
        ExhBegin: '',
        ExhEnd: '',
        eExhVenue: '',

        Exhdate: '',
        DirectoryDeadline: '',
        DirectoryArchived: '',
        RegNo: '',
        ExhibitionName: '',
        Directory_ComName: '',
        UserId: '',
        existProNum: '',
        leftProNum: '',
        existNewsNum: '',
        leftNewsNum: '',
        ProductAmount: '',
        newsAmount: '',
      }
    },

    metaInfo() {
      return {
        title: '首頁 - 展昭參展商管理系統',
      }
    },

    methods: {},

    created() {
      const vm = this

      let nowPage = location.href
      vm.RegNo = nowPage.split('no=')[1]

      axios.get(`https://www.chanchao.com.tw/apiExhibitors/Exhibition/${vm.RegNo}?lang=tw`).then((response) => {
        if (response.data.Code == 200) {
          vm.ExhibitionName = response.data.Data.Exhibition
          vm.ExhVenue = response.data.Data.ExhVenue
          vm.ExhLogo = `//www.ccie.com.tw/exhibition/images/exlogo/${response.data.Data.ExhLogo}`
          vm.Exhdate = response.data.Data.ExhBegin + ' - ' + response.data.Data.ExhEnd
          vm.DirectoryDeadline = response.data.Data.DirectoryDeadline

          vm.ExhBegin = response.data.Data.ExhBegin
          vm.ExhEnd = response.data.Data.ExhEnd
          vm.eExhVenue = response.data.Data.eExhVenue

          if (response.data.Data.DirectoryArchived == 0) {
            $('.progressBook').addClass('hideDirectory')
          } else {
            $('.progressBook').removeClass('hideDirectory')
          }

          if (response.data.Data.DirectoryHardcopy == 1) {
            $('[name="directoryTitle"]').text('會刊登錄')
            $('[name="directoryTitleEn"]').text('Directory Entry')
            $('[name="profileTitleEn"]').text('Basic Information')
            $('[name="homeCompanyInfo"]').text('基本資料')
            $('[name="homeDirectoryTitle"]').text('會刊登錄')
            $('[name="homeDirectoryTitleEn"]').text('Directory Entry')
            $('.HasDirectory').addClass('show')
            $('.NoDirectory').addClass('hide')
          } else {
            $('[name="directoryTitle"]').text('廠商介紹')
            $('[name="directoryTitleEn"]').text('Exhibitor Profile')
            $('[name="profileTitleEn"]').text('Basic Information')
            $('[name="homeCompanyInfo"]').text('基本資料')
            $('[name="homeDirectoryTitle"]').text('廠商介紹')
            $('[name="homeDirectoryTitleEn"]').text('Exhibitor Profile')
            $('.HasDirectory').addClass('hide')
            $('.NoDirectory').addClass('show')
          }
        } else if (response.data.Code == 404) {
          // console.log('查無資料')
        } else {
          alert('系統忙線中，請稍後再試1')
        }
      })

      axios.get(`https://www.chanchao.com.tw/apiExhibitors/Exhibitor/${vm.RegNo}`).then((response) => {
        // console.log(response.data.Code)

        if (response.data.Code == 200) {
          vm.Directory_ComName = response.data.Data.Directory_ComName

          if (response.data.Data.Logo && response.data.Data.Logo !== 'default.jpg' && response.data.Data.BrandName) {
            $('div.profile h3 .icon').addClass('complete')
          }

          vm.ProductAmount = response.data.Data.ProductAmount
          vm.newsAmount = response.data.Data.NewsAmount

          axios
            .get(`https://www.chanchao.com.tw/apiExhibitors/Product/${vm.RegNo}?mode=more&Page=`)
            .then((response) => {
              // console.log(response)

              if (response.data.Code == 200) {
                vm.existProNum = response.data.datatotal
                vm.leftProNum = vm.ProductAmount - response.data.datatotal
              } else if (response.data.Code == 404) {
                vm.existProNum = 0
                vm.leftProNum = vm.ProductAmount - 0
              }
            })

          axios.get(`https://www.chanchao.com.tw/apiExhibitors/ExhibitorNews/${vm.RegNo}?Page=1`).then((response) => {
            if (response.data.Code == 200) {
              vm.existNewsNum = response.data.datatotal
              vm.leftNewsNum = vm.newsAmount - response.data.datatotal
            } else if (response.data.Code == 404) {
              vm.existNewsNum = 0
              vm.leftNewsNum = vm.newsAmount - 0
            }
          })
        } else if (response.data.Code == 404) {
          // console.log('查無資料')
        } else {
          alert('系統忙線中，請稍後再試')
        }
      })

      axios.get(`https://www.chanchao.com.tw/apiExhibitors/Directory/${vm.RegNo}`).then((response) => {
        if (response.data.Data.Product) {
          $('div.directory h3 .icon').addClass('complete')
        }
      })

      axios.get(`https://www.chanchao.com.tw/apiExhibitors/UserID`).then((response) => {
        vm.UserId = response.data
      })

      axios.get(`https://www.chanchao.com.tw/apiExhibitors/MenuInvitation/${vm.RegNo}?lang=tw`).then((response) => {
        if (response.data.Code == 200) {
          $('.progressInvit').removeClass('hideInvit')

          for (var i = 0; i < response.data.Data.length; i++) {
            if (response.data.Data[i].Url == 'inviteReg' || response.data.Data[i].Url == 'invite') {
              // let GetUrl = response.data.Data[i].Url
              // let UrlDelHtml = GetUrl.split('.')[0]
              $('a.getInvUrl').attr('href', response.data.Data[i].Url + '?no=' + vm.RegNo)
            }
          }
        } else {
          $('.progressInvit').addClass('hideInvit')
        }
      })
    },
  }
</script>

<style lang="scss">
  a:hover {
    color: #ffffff;
  }

  .linkstyle:hover {
    color: #0056b3;
  }

  .hide {
    display: none;
  }

  .show {
    display: block;
  }

  #progress li.progressEdit {
    background-image: url('../../assets/images/progressEdit.svg');
  }

  #progress li.progressBook {
    background-image: url('../../assets/images/progressBook.svg');
  }

  #progress li.progressProd {
    background-image: url('../../assets/images/progressProd.svg');
  }

  #progress li.progressNews {
    background-image: url('../../assets/images/progressNews.svg');
  }

  #progress li.progressInvit {
    background-image: url('../../assets/images/progressInvit.svg');
  }

  #progress li h3 span.incomplete {
    width: 18px;
    height: 18px;
    display: inline-block;
    background-image: url('../../assets/images/tickGray.svg');
    background-repeat: no-repeat;
    background-position: left center;
    background-size: auto 100%;
    padding-left: 20px;
  }

  #progress li h3 span.complete {
    background-image: url('../../assets/images/tick.svg');
  }

  .hideDirectory {
    display: none;
  }

  .hideInvit {
    display: none;
  }
</style>
